var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "courseScheduleCreateModal",
      staticClass: "modal fade course-schedules-details",
      attrs: { tabindex: "-1", "aria-hidden": "true" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v("\n                    Add to Schedule\n                "),
            ]),
            _vm._v(" "),
            _c("button", {
              staticClass: "btn-close",
              attrs: { type: "button", "aria-label": "Close" },
              on: {
                click: function ($event) {
                  return _vm.hide()
                },
              },
            }),
          ]),
          _vm._v(" "),
          _vm.courseScheduleForm
            ? _c("div", { staticClass: "modal-body" }, [
                _vm.errors.length
                  ? _c("div", { staticClass: "alert alert-danger" }, [
                      _c(
                        "ul",
                        _vm._l(_vm.errors, function (error) {
                          return _c("li", [_vm._v(_vm._s(error))])
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "row mb-3" }, [
                      _c("div", { staticClass: "col-md-4 label" }, [
                        _vm._v("Path"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.courseScheduleForm.reset_level_id,
                                expression: "courseScheduleForm.reset_level_id",
                              },
                            ],
                            staticClass: "form-select",
                            attrs: { title: "paths" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.courseScheduleForm,
                                  "reset_level_id",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          _vm._l(_vm.library.paths, function (path) {
                            return _c(
                              "option",
                              { domProps: { value: path.id } },
                              [
                                _vm._v(
                                  _vm._s(path.name) +
                                    "\n                                    "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mb-3" }, [
                      _c("div", { staticClass: "col-md-4 label" }, [
                        _vm._v("Status"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.courseScheduleForm.is_active,
                                expression: "courseScheduleForm.is_active",
                              },
                            ],
                            staticClass: "form-select",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.courseScheduleForm,
                                  "is_active",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option", { attrs: { value: "0" } }, [
                              _vm._v("not active"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "1" } }, [
                              _vm._v("active"),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mb-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4 label app-required" },
                        [_vm._v("Date")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.courseScheduleForm.date,
                              expression: "courseScheduleForm.date",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "date" },
                          domProps: { value: _vm.courseScheduleForm.date },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.courseScheduleForm,
                                "date",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mb-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4 label app-required" },
                        [_vm._v("Time")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-1 label" }, [
                        _vm._v("From"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.courseScheduleForm.time_from,
                              expression: "courseScheduleForm.time_from",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "time" },
                          domProps: { value: _vm.courseScheduleForm.time_from },
                          on: {
                            change: function ($event) {
                              return _vm.updateTime("from")
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.courseScheduleForm,
                                "time_from",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-1 label" }, [
                        _vm._v("Till"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.courseScheduleForm.time_till,
                              expression: "courseScheduleForm.time_till",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "time" },
                          domProps: { value: _vm.courseScheduleForm.time_till },
                          on: {
                            change: function ($event) {
                              return _vm.updateTime("till")
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.courseScheduleForm,
                                "time_till",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mb-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4 label app-required" },
                        [_vm._v("Class")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.courseScheduleForm.course_id,
                                expression: "courseScheduleForm.course_id",
                              },
                            ],
                            staticClass: "form-select",
                            attrs: { title: "courses" },
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.courseScheduleForm,
                                    "course_id",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function ($event) {
                                  return _vm.updateTrainer()
                                },
                              ],
                            },
                          },
                          _vm._l(_vm.library.courses, function (course) {
                            return _c(
                              "option",
                              { domProps: { value: course.id } },
                              [
                                _vm._v(
                                  _vm._s(course.name) +
                                    "\n                                    "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mb-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4 label app-required" },
                        [_vm._v("Trainer")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.courseScheduleForm.trainer_id,
                                expression: "courseScheduleForm.trainer_id",
                              },
                            ],
                            staticClass: "form-select",
                            attrs: { title: "trainers" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.courseScheduleForm,
                                  "trainer_id",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "optgroup",
                              { attrs: { label: "prefered" } },
                              _vm._l(
                                _vm.getPreselectedTrainers(),
                                function (trainer) {
                                  return _c(
                                    "option",
                                    { domProps: { value: trainer.id } },
                                    [
                                      _vm._v(
                                        "*   " +
                                          _vm._s(trainer.name) +
                                          "\n                                        "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "optgroup",
                              { attrs: { label: "others" } },
                              _vm._l(
                                _vm.getOthersTrainers(),
                                function (trainer) {
                                  return _c(
                                    "option",
                                    { domProps: { value: trainer.id } },
                                    [
                                      _vm._v(
                                        _vm._s(trainer.name) +
                                          "\n                                        "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mb-3" }, [
                      _c("div", { staticClass: "col-md-4 label" }, [
                        _vm._v("Level"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.courseScheduleForm.course_level_id,
                                expression:
                                  "courseScheduleForm.course_level_id",
                              },
                            ],
                            staticClass: "form-select",
                            attrs: { title: "levels" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.courseScheduleForm,
                                  "course_level_id",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          _vm._l(_vm.library.levels, function (level) {
                            return _c(
                              "option",
                              { domProps: { value: level.id } },
                              [
                                _vm._v(
                                  _vm._s(level.name) +
                                    "\n                                    "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mb-3" }, [
                      _c("div", { staticClass: "col-md-4 label" }, [
                        _vm._v("Capacity"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.courseScheduleForm.capacity,
                              expression: "courseScheduleForm.capacity",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "number" },
                          domProps: { value: _vm.courseScheduleForm.capacity },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.courseScheduleForm,
                                "capacity",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mb-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4 label app-required" },
                        [_vm._v("Location")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.courseScheduleForm.location_id,
                                expression: "courseScheduleForm.location_id",
                              },
                            ],
                            staticClass: "form-select",
                            attrs: { title: "locations" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.courseScheduleForm,
                                  "location_id",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          _vm._l(_vm.library.locations, function (location) {
                            return _c(
                              "option",
                              { domProps: { value: location.id } },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(location.name) +
                                    "\n                                    "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mb-3" }, [
                      _c("div", { staticClass: "col-md-4 label" }, [
                        _vm._v("Location comment"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.courseScheduleForm.location_comment,
                              expression: "courseScheduleForm.location_comment",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", maxlength: "150" },
                          domProps: {
                            value: _vm.courseScheduleForm.location_comment,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.courseScheduleForm,
                                "location_comment",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.hide()
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button", disabled: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v("Create\n                    ")]
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "app-required" }),
      _vm._v(
        " This field will be displayed in the RESET Guest App.\n                "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "text-danger small" }, [
        _vm._v("Changing current schedule does not update existing template."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }